import React, { useCallback, useEffect, useState } from 'react'
import { FiCopy, FiPlus } from 'react-icons/fi'

import { MenuProps, CategoryProps } from 'utils/props'
import { useTotem } from 'contexts/TotemContext'
import { useToast } from 'contexts/ToastContext'
import { api } from 'services/api'

import Spinner from 'components/Spinner'
import CategoriesCard from './CategoriesCard'
import CategoryModal from './CategoryModal'
import CopyCategoryModal from './CopyCategoryModal'

import * as S from './styles'

const Category: React.FC = () => {
  const { totem, setTotem } = useTotem()
  const { showToast } = useToast()
  const [isLoading, setIsLoading] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenCopy, setIsOpenCopy] = useState(false)
  const [categories, setCategories] = useState<CategoryProps[]>([])
  const [categorySelected, setCategorySelected] = useState<CategoryProps>(null)

  const loadMenusData = useCallback(async () => {
    setIsLoading(true)

    try {
      const { data } = await api('user-api').get<MenuProps>(
        `menus/${totem.menuId}`
      )

      setCategories(data.categories)
    } finally {
      setIsLoading(false)
    }
  }, [totem?.menuId])

  useEffect(() => {
    loadMenusData()
  }, [loadMenusData])

  const handleToggleModal = useCallback((category: CategoryProps = null) => {
    setIsOpen((prevState: boolean) => !prevState)
    setCategorySelected(category)
  }, [])

  const handleToggleCopyModal = useCallback(() => {
    setIsOpenCopy(!isOpenCopy)
  }, [isOpenCopy])

  const handleUpdateCategories = useCallback(
    async ({ value }) => {
      try {
        const { data } = await api('user-api').put(`menus/${totem.menuId}`, {
          categories: value
        })

        setTotem({
          ...totem,
          menu: {
            ...totem.menu,
            categories: value
          }
        })

        showToast({
          message: 'Cardápio atualizado com sucesso!',
          type: 'success'
        })
      } catch (err) {
        const message =
          err?.response?.data?.error ||
          'Por Favor entrar em contato com suporte.'

        showToast({ message, type: 'error' })
      }
    },
    [setTotem, showToast, totem]
  )

  if (isLoading) {
    return <Spinner />
  }

  return (
    <S.Container>
      <CategoryModal
        isOpen={isOpen}
        handleToggle={handleToggleModal}
        categories={categories}
        setCategories={setCategories}
        category={categorySelected}
        handleUpdateCategories={handleUpdateCategories}
      />

      <CopyCategoryModal
        isOpen={isOpenCopy}
        handleToggle={handleToggleCopyModal}
        categories={categories}
        setCategories={setCategories}
        handleUpdateCategories={handleUpdateCategories}
      />

      <S.Title>Cardápio</S.Title>

      <S.Options>
        <S.ButtonAdd type="button" onClick={() => handleToggleModal()}>
          <FiPlus /> Adicionar categoria
        </S.ButtonAdd>

        <S.ButtonCopy type="button" onClick={handleToggleCopyModal}>
          <FiCopy /> Copiar de outro cardápio
        </S.ButtonCopy>
      </S.Options>

      <CategoriesCard
        categories={categories}
        setCategories={setCategories}
        handleToggle={handleToggleModal}
        handleUpdateCategories={handleUpdateCategories}
      />
    </S.Container>
  )
}

export default Category
